<template>
  <div class="members-wrapper">
    <el-row :gutter="25">
      <el-col :span="12">
        <div :class="['item', netBarVIP ? 'item_bg' : '']">
          <img
            class="icon"
            v-if="netBarVIP"
            src="@/assets/images/members/status.png"
            alt=""
          />
          <h3>
            <img
              :src="
                netBarVIP
                  ? require('@/assets/images/members/member-icon_02.png')
                  : require('@/assets/images/members/member-icon_01.png')
              "
              alt=""
            />
            钻石版介绍
          </h3>
          <p>是网吧老板为顾客开通会员特权<br />网吧顾客所有人可用</p>

          <el-row :gutter="8" class="item-box">
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">1免费</div>
                <div class="text">
                  游戏大厅海量<br />游戏<br />免费畅玩，玩<br />到手软
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">2免费</div>
                <div class="text">
                  不花钱玩3A大<br />作、热门大作<br />无需花重金，<br />每年省1888元<br />购买账号费用
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">3免费</div>
                <div class="text">
                  最新游戏闪电<br />上架<br />顶级大作 抢先<br />体验<br />定期更新各种<br />热门游戏
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">4免费</div>
                <div class="text">
                  自动存档，完<br />美延续<br />更有完美存档<br />任性体验
                </div>
              </div>
            </el-col>
          </el-row>

          <div class="button" v-if="netBarVIP" @click="diamond">
            {{ netBarVIPEndTime.substr(0, 10) }}到期 立即续费
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div :class="['item', !netBarVIP ? 'item_bg' : '']">
          <img
            class="icon"
            v-if="!netBarVIP"
            src="@/assets/images/members/status.png"
            alt=""
          />
          <h3>
            <img
              :src="
                !netBarVIP
                  ? require('@/assets/images/members/member-icon_02.png')
                  : require('@/assets/images/members/member-icon_01.png')
              "
              alt=""
            />
            黄金版介绍
          </h3>
          <p>网吧老板没有为您开通会员特权</p>
          <div class="title">方案一：开通个人会员特权，所有游戏免费玩</div>

          <div class="button" v-if="!netBarVIP && userInfo" @click="open()">
            {{ userInfo.IsNotMember ? userInfo.MemberExpirationDate.split(" ")[0] + '到期 续费' : '立即开通会员特权' }}
          </div>
          
          
          <div class="title">方案二：联系网吧维护或老板开通钻石版</div>
          <div class="content">
            可以通过桌面呼叫或留言或者直接找网吧服务人员提交<br />要求开通后，全网吧可用会员特权
          </div>
          <div
            class="button"
            v-if="!netBarVIP && netBarInfo && netBarInfo.AddMoneySwitch"
            @click="diamond"
          >
            立即开通钻石版会员
          </div>

          <el-row :gutter="8" class="item-box">
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: !netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">1免费</div>
                <div class="text">
                  游戏大厅海量<br />游戏<br />免费畅玩，玩<br />到手软
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: !netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">2免费</div>
                <div class="text">
                  不花钱玩3A大<br />作、热门大作<br />无需花重金，<br />每年省1888元<br />购买账号费用
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: !netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">3免费</div>
                <div class="text">
                  最新游戏闪电<br />上架<br />顶级大作 抢先<br />体验<br />定期更新各种<br />热门游戏
                </div>
              </div>
            </el-col>
            <el-col :span="6">
              <div
                class="grid-item"
                :style="{
                  background: !netBarVIP
                    ? `url(${backgroundImage2}) no-repeat`
                    : `url(${backgroundImage1}) no-repeat`,
                }"
              >
                <h4>开通可享</h4>
                <div class="bt" @click="$router.push('/home')">4免费</div>
                <div class="text">
                  自动存档，完<br />美延续<br />更有完美存档<br />任性体验
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>

    <!-- 开通会员弹窗 -->
    <MembersBuy :isShow="isShow" @changeShow="showDialogVisible" />

    <!-- 钻石版开通 -->
    <DiamondEdition ref="diamod" :netBarInfo="netBarInfo" />

    <!-- 错误信息提示 -->
    <el-dialog
      title="温馨提示："
      :visible.sync="errorDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
    >
      <span class="text-content">{{ errorDialogStr }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onLineService"
          >联系客服解决</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { GetMemberPackage, CrateOrder, GetOrderPayState } from "@/api";
import { mapGetters } from "vuex";
import QRCode from "qrcode";
import MembersBuy from "./components/MembersBuy.vue";
import DiamondEdition from "./components/DiamondEdition.vue";
import cMethods from "@/util/cMethods.js";

export default {
  name: "Members",
  components: {
    MembersBuy,
    DiamondEdition,
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "userInfo",
      "netBarId",
      "netBarName",
      "netBarVIP",
      "netBarVIPEndTime",
      "getIsAuth",
      "getTheme",
    ]),
  },
  data() {
    return {
      errorDialogStr: "",
      errorDialogVisible: false,
      backgroundImage1: require("@/assets/images/members/grid_item_bg1.png"),
      backgroundImage2: require("@/assets/images/members/grid_item_bg2.png"),
      isShow: false,
      memBersList: [],
      checked: true,
      vipCount: 0,
      payWay: 1, // 支付方式：1.支付宝支付  2.微信支付
      hover: false,
      qrCode: "",
      first: 0,
      orderCode: "",
      OrderNo: "",
      ExchangeHoverIs: false,
      timer: 0,
      visibleDialog: false,
      netBarInfo: null,
    };
  },
  mounted() {
    // this._GetMemberPackage();
    // 获取网吧信息
    if (this.netBarId) {
      this.$store.dispatch("_GetNetbarInfo", {
        netBarId: parseInt(this.netBarId),
        callback: (netbarInfo) => {
          this.netBarInfo = netbarInfo;
          if (this.netBarVIP) {
            this.$statistic(["A", "钻石版", "VIP会员页", "访问量"]);
          } else {
            this.$statistic(["A", "黄金版", "VIP会员页", "访问量"]);
          }
        },
      });
    }
    // 统计
    this.$statistic(["A", "买VIP会员页", "网页", "访问量"]);
  },
  methods: {
    // activateNow() {
    //   if (this.isLogin) {
    //     this.visibleDialog = true;
    //     if (this.netBarId) {
    //       this._GetNetbarInfo();
    //     }
    //     this.$statistic(["B", "我的会员", "通知网吧管理", "点击量"]);
    //   } else {
    //     eventBus.$emit("getQrCode");
    //   }
    // },
    // 在线人工客服
    onLineService(e) {
      cMethods.OpenIeUrl(
        "http://www.mayidianjing.com/Content/customerService/xiaoneng.html"
      );
    },
    // 会员购买弹窗
    showDialogVisible(data) {
      if (data === "false") {
        this.isShow = false;
      } else {
        this.isShow = true;
      }
    },
    // 钻石版开通
    diamond() {
      // 外挂检测
      if (cMethods.jsGetWhetherTheMachineIsOnOrOff() > 0) {
        this.errorDialogStr =
          "检测到本机有可疑程序【" +
          cMethods.jsGetWhetherTheMachineIsOnOrOff() +
          "】，禁止上号！";
        this.$statistic(["A", "游戏详情页面", "取号检测到外挂", "展现量"]);
        this.errorDialogVisible = true;
        return;
      }

      if (this.netBarInfo && this.netBarInfo.AddMoneySwitch == 1) {
        this.$refs.diamod.openDialog();
      } else {
        this.$message.error("请联系网吧维护开通或续费！");
      }

      this.$statistic(["B", "我的会员", "钻石版续费按钮点击量", "点击量"]);
    },
    // 获取会员套餐列表
    async _GetMemberPackage() {
      let params = {};
      let res = await GetMemberPackage();
      if (res.StatusCode == 200) {
        this.memBersList = res.Object;
      }
    },
    // 开通会员弹窗
    open() {
      if (this.isLogin) {
        // 外挂检测
        if (cMethods.jsGetWhetherTheMachineIsOnOrOff() > 0) {
          this.errorDialogStr =
            "检测到本机有可疑程序【" +
            cMethods.jsGetWhetherTheMachineIsOnOrOff() +
            "】，禁止上号！";
          this.$statistic(["A", "游戏详情页面", "取号检测到外挂", "展现量"]);
          this.errorDialogVisible = true;
          return;
        }

        // 是否绑定手机号
        let phone = sessionStorage.getItem("Phone");

        if (phone) {
          if (this.getIsAuth && !this.userInfo.IDCard) {
            eventBus.$emit("showAuth");
            return false;
          }
          this.isShow = true;
        } else {
          eventBus.$emit("showLoginPhone");
        }
      } else {
        eventBus.$emit("getQrCode");
      }
      this.$statistic(["A", "买VIP会员页", "付款码", "展现量"]);
    },
    // 复制成功时的回调函数
    onCopy(e) {
      this.$message({
        type: "success",
        message: "内容已复制到剪切板！",
      });
    },
    // 复制失败时的回调函数
    onError(e) {
      this.$message.error("抱歉，复制失败！");
      this.$message({
        type: "error",
        message: "抱歉,复制失败！",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.members-wrapper {
  width: 1040px;
  padding: 20px;

  .item {
    height: 677px;
    display: flex;
    // justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 35px 20px;
    background: $white-col;
    border-radius: 20px;
    box-sizing: border-box;
    position: relative;
    .icon {
      position: absolute;
      top: 0;
      right: 20px;
    }
    &.item_bg {
      background: url("./../assets/images/members/bg.png") no-repeat;
      background-size: 100% 100%;
    }
    h3 {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 26px;
      line-height: 24px;
      color: #333;
      img {
        margin-right: 10px;
      }
    }
    .title {
      margin: 20px 0;
      font-size: 18px;
      line-height: 24px;
      color: #333;
    }
    .content {
      font-size: 16px;
      color: #999;
      line-height: 24px;
      margin-bottom: 10px;
    }
    .button {
      width: 280px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: linear-gradient(90deg, #be5b00 0%, #7e3c0a 100%);
      border-radius: 18px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
    }
    p {
      margin-top: 20px;
      text-align: center;
      font-size: 18px;
      color: #999;
      line-height: 30px;
    }
    .item-box {
      margin-top: 30px;
      margin-bottom: 60px;
      display: flex;
      flex-direction: row;
      width: 100%;
      .grid-item {
        width: 108.88px;
        height: 240px;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        color: #666;
        padding: 16px 8px;
        box-sizing: border-box;

        h4 {
          font-size: 16px;
          font-weight: bold;
          color: #333;
          margin-bottom: 12px;
        }
        .bt {
          width: 66px;
          height: 26px;
          line-height: 26px;
          text-align: center;
          border-radius: 4px;
          border: 1px solid #666666;
          margin-bottom: 16px;
          cursor: pointer;
        }
        .text {
          line-height: 24px;
        }
      }
    }
  }

  // .members-info {
  //   width: 1040px;
  //   height: 230px;
  //   background: url("./../assets/images/members/bg.jpg") no-repeat;
  //   background-size: 100% 100%;
  //   box-shadow: -2px 0px 10px 0px rgba(0, 0, 0, 0.2);
  // }

  // .opening-member {
  //   width: 391px;
  //   height: 206px;
  //   float: left;
  //   margin-top: 12px;
  //   margin-left: 56px;
  //   background: url("./../assets/images/members/member.png") no-repeat;
  //   background-size: 100% 100%;
  //   text-align: center;

  //   .my-member {
  //     margin-top: 30px;
  //     background: url("./../assets/images/members/title-bg.png") no-repeat;
  //     background-position: center center;
  //     color: #feeac5;
  //     font-size: 18px;
  //   }

  //   h3 {
  //     margin-top: 14px;
  //     margin-bottom: 40px;
  //     color: $white-col;
  //     font-size: 16px;
  //     line-height: 20px;
  //     padding: 0 10px;

  //     a {
  //       color: #333;
  //       text-decoration: underline;
  //     }
  //   }

  //   .btn {
  //     width: 240px;
  //     height: 44px;
  //     display: block;
  //     margin: 0 auto;
  //     background: url("./../assets/images/members/btn.png") no-repeat;
  //     background-size: 100% 100%;
  //     cursor: pointer;
  //   }

  //   .btn:hover {
  //     transform: translateY(-2px);
  //   }

  //   .toOpen {
  //     padding: 0 20px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-between;

  //     .buy {
  //       width: 180px;
  //       height: 44px;
  //       line-height: 44px;
  //       display: block;
  //       color: #fff;
  //       background: #ca8b4e;
  //       border-radius: 22px;
  //       font-size: 16px;
  //       cursor: pointer;
  //     }
  //   }

  //   .tobuy {
  //     width: 240px;
  //     height: 44px;
  //     line-height: 44px;
  //     display: block;
  //     margin: 0 auto;
  //     color: #fff;
  //     background: #ca8b4e;
  //     border-radius: 22px;
  //   }

  //   .isVip {
  //     margin-top: 40px;
  //   }

  //   p {
  //     font-size: 16px;
  //     color: $white-col;
  //   }
  // }

  // .members-box {
  //   width: 474px;
  //   padding: 47px 0;
  //   margin-left: 60px;
  //   text-align: center;
  //   float: left;
  // }

  // .privileges-info {
  //   height: 366px;
  //   margin-top: 20px;
  //   padding-top: 60px;
  //   position: relative;
  //   background-size: 100% 100%;
  //   text-align: center;
  //   @include item_bg_col();
  //   box-shadow: -2px 0px 10px 0px rgba(0, 0, 0, 0.2);

  //   .btn-box {
  //     position: absolute;
  //     bottom: 320px;
  //     right: 30px;
  //     z-index: 999;

  //     .order,
  //     .coupons {
  //       width: 76px;
  //       height: 76px;
  //       border-radius: 38px;
  //     }
  //   }

  //   .title {
  //     text-align: center;
  //   }
  // }

  // .renewal-box {
  //   padding: 40px 60px;

  //   .item.active {
  //     border: 1px solid #c2a36c;
  //   }

  //   .item {
  //     height: 256px;
  //     @include tag_bg_col();
  //     position: relative;
  //     cursor: pointer;
  //     text-align: center;

  //     .icon {
  //       position: absolute;
  //       top: -7px;
  //       left: -7px;
  //     }

  //     a {
  //       height: 256px;
  //       display: block;
  //       z-index: 9999;
  //     }

  //     .time {
  //       line-height: 25px;
  //       font-size: 28px;
  //       margin-bottom: 30px;
  //       display: flex;
  //       justify-content: center;
  //       align-items: center;
  //       @include font_col3();

  //       img {
  //         width: 27px;
  //         height: 28px;
  //         margin: 0 10px;
  //       }

  //       .giveDays {
  //         font-size: 28px;
  //         color: #f02828;
  //       }
  //     }

  //     .price {
  //       font-size: 22px;
  //       font-weight: 500;
  //       color: #f02828;
  //       margin-bottom: 15px;

  //       span {
  //         font-size: 24px;
  //       }
  //     }

  //     .original-price {
  //       text-decoration: line-through;
  //       font-size: 18px;
  //       @include font_col9();
  //     }

  //     .text {
  //       height: 44px;
  //       line-height: 44px;

  //       img {
  //         width: 239px;
  //         height: 44px;
  //       }
  //     }
  //   }

  //   .item:hover {
  //     border: 1px solid #c2a36c;
  //   }

  //   .content {
  //     padding: 40px 0 30px 0;
  //   }
  // }
}
</style>
<style lang="scss">
.visible-dialog {
  .content {
    line-height: 26px;
    font-size: 15px;

    .copy {
      margin-left: 20px;
      background: #ff3636;
      color: #fff;
      font-size: 14px;
      padding: 5px 10px;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>